var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDeletePoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 198,
    viewBox: "0 0 200 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_882_36227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.224 41.2354H54.3426C47.732 41.2354 42.373 46.603 42.373 53.2244V144.254C42.373 150.875 47.732 156.243 54.3426 156.243H145.224C151.835 156.243 157.194 150.875 157.194 144.254V53.2244C157.194 46.603 151.835 41.2354 145.224 41.2354Z",
    fill: "#FFF6F6"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 22.5,
    y: 21.5,
    width: 155,
    height: 155,
    rx: 28.5,
    stroke: "#E93333",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 13.5,
    y: 12.5,
    width: 173,
    height: 173,
    rx: 33.5,
    stroke: "#E93333",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 5.5,
    y: 4.5,
    width: 189,
    height: 189,
    rx: 39.5,
    stroke: "#E93333",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 30C39.9543 30 31 38.9543 31 50V148C31 159.046 39.9543 168 51 168H149C160.046 168 169 159.046 169 148V50C169 38.9543 160.046 30 149 30H51ZM53.0882 36.0882C44.2517 36.0882 37.0882 43.2517 37.0882 52.0882V145.912C37.0882 154.748 44.2517 161.912 53.0882 161.912H146.912C155.748 161.912 162.912 154.748 162.912 145.912V52.0882C162.912 43.2517 155.748 36.0882 146.912 36.0882H53.0882Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.399 137.826H67.6422C64.6703 137.826 62.2588 140.237 62.2588 143.209V144.105C62.2588 144.601 62.663 145 63.1545 145H136.887C137.383 145 137.782 144.601 137.782 144.105V143.209C137.782 140.237 135.371 137.826 132.399 137.826Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.8125,
    y: 62.0942,
    width: 40.3745,
    height: 22.2352,
    fill: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4082 78.2571C96.9066 78.6963 96.9066 79.4649 96.4082 79.9041C96.1782 80.1237 95.8715 80.2335 95.5647 80.2335C95.2197 80.2335 94.913 80.1237 94.6829 79.9041L90.6573 76.0611L86.5932 79.9041C86.3632 80.1237 86.0565 80.2335 85.7498 80.2335C85.4047 80.2335 85.098 80.1237 84.868 79.9041C84.3695 79.4649 84.3695 78.6963 84.868 78.2571L88.8936 74.3776L84.868 70.5346C84.3695 70.0954 84.3695 69.3268 84.868 68.8876C85.328 68.4118 86.1332 68.4118 86.5932 68.8876L90.6573 72.7306L94.6829 68.8876C95.143 68.4118 95.9481 68.4118 96.4082 68.8876C96.9066 69.3268 96.9066 70.0954 96.4082 70.5346L92.3825 74.4142L96.4082 78.2571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.718 78.2571C116.216 78.6963 116.216 79.4649 115.718 79.9041C115.488 80.1237 115.181 80.2335 114.874 80.2335C114.529 80.2335 114.223 80.1237 113.992 79.9041L109.967 76.0611L105.903 79.9041C105.673 80.1237 105.366 80.2335 105.059 80.2335C104.714 80.2335 104.408 80.1237 104.178 79.9041C103.679 79.4649 103.679 78.6963 104.178 78.2571L108.203 74.3776L104.178 70.5346C103.679 70.0954 103.679 69.3268 104.178 68.8876C104.638 68.4118 105.443 68.4118 105.903 68.8876L109.967 72.7306L113.992 68.8876C114.453 68.4118 115.258 68.4118 115.718 68.8876C116.216 69.3268 116.216 70.0954 115.718 70.5346L111.692 74.4142L115.718 78.2571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.729 58.8795C128.729 55.9076 126.318 53.4961 123.346 53.4961H76.6959C73.724 53.4961 71.3125 55.9076 71.3125 58.8795V134.238H128.729V58.8795ZM100.021 128.854C89.6307 128.854 81.179 120.403 81.179 110.017C81.179 99.6315 89.6307 91.1752 100.021 91.1752C110.411 91.1752 118.863 99.6269 118.863 110.017C118.863 120.407 110.411 128.854 100.021 128.854ZM123.346 85.7918C123.346 86.784 122.542 87.5878 121.554 87.5878H78.4919C77.4997 87.5878 76.6959 86.784 76.6959 85.7918V60.6755C76.6959 59.6833 77.4997 58.8795 78.4919 58.8795H121.554C122.542 58.8795 123.346 59.6833 123.346 60.6755V85.7964V85.7918Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.77 110.013C84.77 101.607 91.6095 94.7632 100.02 94.7632C108.43 94.7632 115.27 101.607 115.27 110.013C115.27 118.419 108.43 125.263 100.02 125.263C91.6095 125.263 84.77 118.419 84.77 110.013Z",
    fill: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4917 120.608C97.3542 120.608 97.2136 120.578 97.0823 120.515C96.6652 120.315 96.4443 119.841 96.554 119.382L98.4155 111.722H94.8222C94.4623 111.722 94.1317 111.516 93.9648 111.188C93.798 110.859 93.8258 110.466 94.0343 110.164L101.093 99.9615C101.351 99.5903 101.82 99.4465 102.231 99.6108C102.644 99.7751 102.895 100.206 102.838 100.655L102.033 107.113H105.764C106.129 107.113 106.462 107.322 106.625 107.655C106.79 107.987 106.758 108.385 106.543 108.685L98.2687 120.206C98.0818 120.466 97.7898 120.608 97.4901 120.608H97.4917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 165.5,
    r: 30.5,
    fill: "#FF6B6B",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.938 151.125C161.25 150.438 161.938 150 162.688 150H170.25C171 150 171.688 150.438 172 151.125L172.5 152H178.5C179.562 152 180.5 152.938 180.5 154C180.5 155.125 179.562 156 178.5 156H154.5C153.375 156 152.5 155.125 152.5 154C152.5 152.938 153.375 152 154.5 152H160.5L160.938 151.125ZM154.438 158H178.5V178C178.5 180.25 176.688 182 174.5 182H158.438C156.25 182 154.438 180.25 154.438 178V158ZM159.438 163V177C159.438 177.562 159.938 178 160.438 178C161 178 161.438 177.562 161.438 177V163C161.438 162.5 161 162 160.438 162C159.938 162 159.438 162.5 159.438 163ZM165.438 163V177C165.438 177.562 165.938 178 166.438 178C167 178 167.5 177.562 167.5 177V163C167.5 162.5 167 162 166.438 162C165.938 162 165.438 162.5 165.438 163ZM171.5 163V177C171.5 177.562 171.938 178 172.5 178C173 178 173.5 177.562 173.5 177V163C173.5 162.5 173 162 172.5 162C171.938 162 171.5 162.5 171.5 163Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_882_36227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 198,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeletePoint);
export default __webpack_public_path__ + "static/media/img_delete_point.736a83e20ef6ed304f66a8bc2ada60a9.svg";
export { ForwardRef as ReactComponent };